import { GiftCardsApiClient } from '@fourthwall/services/dist/GiftCardsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreateGiftCardGroupMutation = createMutationHook(
  GiftCardsApiClient.createGiftCardGroup,
  {
    mutationKey: ['createGiftCardGroup'],
  },
)
